import React from 'react';

import { navigate, RouteComponentProps } from '@reach/router';

import { IAuthActions, ILoginForm } from '../../../store/auth/actions';
import { INotificationsActions } from '../../../store/notification/actions';

import Button from '../../../components/Button';
import { FormConsumer, FormProvider, IFormAttributes } from '../../../components/Forms';
import Input from '../../../components/Input';

import { redWaglLogo } from '../../../assets/images';

interface IProps extends RouteComponentProps {
  actions: {
    auth: IAuthActions;
    notifications: INotificationsActions;
  };
}

const RequestNewPassword = (props: IProps) => {
  const {
    actions: {
      auth: { requestResetPassword },
      notifications: { push: pushNotifications }
    },
    location
  } = props;

  const onSubmit = async (data: ILoginForm): Promise<void> => {
    const response = await requestResetPassword(data);

    if (response.errors && response.errors.resetPassword) {
      pushNotifications({
        status: 'unread',
        text: response.errors.resetPassword.msg || 'There was an error',
        type: 'error'
      });
    } else {
      pushNotifications({
        status: 'unread',
        text: 'Password reset e-mail has been sent',
        type: 'success'
      });

      navigate('/login');
    }
  };

  const goToLogin = () => {
    const section = location && location.href.includes('staff') ? '/staff' : '';

    navigate(`${section}/login`);
  };

  return (
    <FormProvider
      defaultValues={{ email: '' }}
      onSubmit={onSubmit}
      validations={{
        email: 'required'
      }}
    >
      <FormConsumer>
        {({ formActions: { setValue }, errors }: IFormAttributes) => (
          <div className="login form wrapper">
            <div>
              <div className="logo-wrapper">
                <img src={redWaglLogo} className="logo" alt="logo" />
              </div>

              <h1>PASSWORD RESET</h1>

              <p>
                Please provide the email address you use when logging into WAGL. We’ll send the
                steps to resetting your passord there.
              </p>

              <Input
                label="EMAIL"
                id="email"
                type="email"
                onChange={setValue('email')}
                hasError={errors.email}
                errorMessage="You must provide a valid email"
                fullWidth={true}
              />

              <Button
                id="login"
                variant="contained"
                color="primary"
                disabled={errors.FORM}
                type="submit"
                className="button button-shadow"
              >
                SUBMIT REQUEST
              </Button>

              <Button
                id="login"
                onClick={goToLogin}
                color="primary"
                type="button"
                className="button button-shadow"
              >
                CANCEL
              </Button>
            </div>
          </div>
        )}
      </FormConsumer>
    </FormProvider>
  );
};

export { RequestNewPassword };
